import request, { skippedRequest } from './request';
import { v4 as uuidv4 } from 'uuid';
import i18n from './i18n';
import * as Auths from './auth';
import * as Constants from './constants';
import * as Routes from './routes';
import DOMPurify from "dompurify";
import jsQR from 'jsqr';
import moment from 'moment';
import pica from "pica";
import ReactGA from "react-ga4";

export const General = {
  getConstant: (path, code) => {
    var result = {
      'name': 'notset',
      'label': 'notset',
      'this': {},
      'list': [],
      'inputList': []
    };

    Object.keys(path).forEach(function (key) {
      let item = path[key];

      // Mapping input list
      result.inputList.push({
        name: item.name,
        value: item.code,
        label: item.label,
        checked: item.code === code ? true : false,
      })

      result.list.push(item);
    });

    if (code || code === 0) {
      Object.keys(path).forEach(function (key) {
        let item = path[key];

        // Set value and label
        if (item.code === code) {
          result.name = item.name;
          result.label = item.label;
          result.this = item;
        }
      });
    }

    return result;
  },
  makeConstant: (textList, prefix) => {
    var result = {};
    textList.forEach((item) => {
      let pattern = prefix + '_' + item;
      result['_' + item] = {
        code: item,
        name: pattern,
        label: pattern,
      }
    });

    return result;
  },
  generatePassword: () => {
    var password = "";
    var length = 3;
    var charset = "notset";

    charset = "abcdefghijklmnopqrstuvwxyz";
    for (var i = 0, q = charset.length; i < length; ++i) {
      password += charset.charAt(Math.floor(Math.random() * q));
    }

    charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (var j = 0, w = charset.length; j < length; ++j) {
      password += charset.charAt(Math.floor(Math.random() * w));
    }

    charset = "0123456789";
    for (var k = 0, e = charset.length; k < length; ++k) {
      password += charset.charAt(Math.floor(Math.random() * e));
    }

    // charset = "!@#$%^&*()<>";
    // charset = "@";
    // for (var l = 0, r = charset.length; l < length; ++l) {
    //   password += charset.charAt(Math.floor(Math.random() * r));
    // }

    return password;
  },
  isDevelopment: () => {
    return process.env.NODE_ENV === 'development';
  },
  isAdmin: (authUser) => {
    return authUser?.roleCode === Constants.User.Role.Root.code ||
      authUser?.roleCode === Constants.User.Role.Admin.code;
  },
  initializeAnalytics: () => {
    const isDevelopment = General.isDevelopment();
    const measurementId = process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;
    if (!isDevelopment && measurementId) {
      ReactGA.initialize(measurementId);
      console.info(`Google Analytics ga4 initialize: ${measurementId}`);
    }
  }
};

export const DateTime = {
  addYears: (datetime, years) => {
    var result = new Date(datetime);
    result.setFullYear(result.getFullYear() + years);
    return result;
  },
  addMonths: (datetime, months) => {
    var result = new Date(datetime);
    result.setMonth(result.getMonth() + months);
    return result;
  },
  addDays: (datetime, days) => {
    var result = new Date(datetime);
    result.setDate(result.getDate() + days);
    return result;
  },
  addHours: (datetime, hours) => {
    var result = new Date(datetime);
    result.setHours(result.getHours() + hours);
    return result;
  },
  addMinutes: (datetime, minutes) => {
    var result = new Date(datetime);
    result.setMinutes(result.getMinutes() + minutes);
    return result;
  },
  addSeconds: (datetime, seconds) => {
    var result = new Date(datetime);
    result.setSeconds(result.getSeconds() + seconds);
    return result;
  },
  randomBetween: (start, end) => {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  },
  getMonthFirstDate: (datetime) => {
    return new Date(datetime.getFullYear(), datetime.getMonth(), 1, 0, 0, 0, 0);
  },
  getMonthLastDate: (datetime) => {
    return new Date(datetime.getFullYear(), datetime.getMonth() + 1, 0, 23, 59, 59, 999);
  },
  getStartOfDay: (datetime) => {
    return new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate(), 0, 0, 0, 0);
  },
  getEndOfDay: (datetime) => {
    return new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate(), 23, 59, 59, 999);
  },
  makeYearMonthInfo: (yearMonth) => {
    if (!yearMonth) {
      return 'yyyy-MM-dd ~ yyyy-MM-dd';
    }

    var calculateDate = new Date(yearMonth);
    var firstDate = DateTime.getMonthFirstDate(calculateDate);
    var lastDate = DateTime.getMonthFirstDate(calculateDate);

    return DateTime.format(firstDate, 'yyyy-MM-dd') + ' ~ ' + DateTime.format(lastDate, 'yyyy-MM-dd');
  },
  makeDatesInMonth: (datetime) => {
    const originDate = new Date(datetime);
    const date = DateTime.getMonthFirstDate(originDate);

    const dates = [];

    while (date.getMonth() === originDate.getMonth()) {
      dates.push({
        id: DateTime.format(date, 'yyyy-MM-dd'),
        date: new Date(date),
        formattedDate: DateTime.format(date, 'yyyy-MM-dd'),
      });
      date.setDate(date.getDate() + 1);
    }

    return dates;
  },
  format: (datetime, format) => {
    if (!datetime) return "";
    format = format.replace(/yyyy/g, datetime.getFullYear());
    format = format.replace(/MM/g, ('0' + (datetime.getMonth() + 1)).slice(-2));
    format = format.replace(/M/g, datetime.getMonth() + 1);
    format = format.replace(/dd/g, ('0' + datetime.getDate()).slice(-2));
    format = format.replace(/d/g, datetime.getDate());
    format = format.replace(/HH/g, ('0' + datetime.getHours()).slice(-2));
    format = format.replace(/H/g, datetime.getHours());
    format = format.replace(/mm/g, ('0' + datetime.getMinutes()).slice(-2));
    format = format.replace(/m/g, datetime.getMinutes());
    format = format.replace(/ss/g, ('0' + datetime.getSeconds()).slice(-2));

    return format;
  },
  createByString: (dateString, timeString) => {
    return new Date(`${DateTime.format(new Date(dateString), 'yyyy-MM-dd')} ${timeString}`);
  },
  equalYearMonth: (datetimeA, datetimeB) => {
    return DateTime.format(new Date(datetimeA), 'yyyy-MM') === DateTime.format(new Date(datetimeB), 'yyyy-MM');
  },
  equalDate: (datetimeA, datetimeB) => {
    return DateTime.format(new Date(datetimeA), 'yyyy-MM-dd') === DateTime.format(new Date(datetimeB), 'yyyy-MM-dd');
  },
  millisToTime: (millis) => {
    if (!millis) {
      return {
        'minutes': 0,
        'seconds': 0,
      };
    }

    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    seconds = (seconds < 10 ? '0' : '') + seconds;

    return {
      'minutes': minutes,
      'seconds': seconds,
    };
  },
  secondsToTime: (inputSeconds) => {
    if (!inputSeconds || inputSeconds === 0) {
      return {
        'hours': '00',
        'minutes': '00',
        'seconds': '00',
        'subSeconds': '00',
        'shortLabel': '00:00',
        'label': '00:00:00.00'
      };
    }

    var hours = Math.floor(inputSeconds / 3600);
    var minutes = Math.floor((inputSeconds - (hours * 3600)) / 60);
    var seconds = Math.floor(inputSeconds - (hours * 3600) - (minutes * 60));
    var subSeconds = Math.floor((inputSeconds % 1).toFixed(2) * 100);

    const format = function (time) {
      if (time === 0) {
        return '00'
      }
      return (time < 10 ? '0' : '') + time;
    }

    hours = format(hours);
    minutes = format(minutes);
    seconds = format(seconds);
    subSeconds = format(subSeconds);

    return {
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds,
      'subSeconds': subSeconds,
      'shortLabel': hours + ':' + minutes,
      'label': hours + ':' + minutes + ':' + seconds + '.' + subSeconds
    };
  },
  timeToSeconds: (time) => {
    var seconds = 0;
    if (!time) { return seconds; }
    var fragments = time.split(':'); // split it at the colons
    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    if (fragments.length === 2) {
      seconds = (+fragments[0]) * 60 * 60 + (+fragments[1]) * 60;
    }
    if (fragments.length === 3) {
      seconds = (+fragments[0]) * 60 * 60 + (+fragments[1]) * 60 + (+fragments[2]);
    }

    return seconds;
  },
  roundDate30Minutes: (date) => {
    const minutes = 30;
    const ms = 1000 * 60 * minutes;

    // 👇️ replace Math.round with Math.ceil to always round UP
    return new Date(Math.round(date.getTime() / ms) * ms);
  },
  makeTimeSelectList: () => {
    var result = [];

    for (let i = 0; i < 48; i++) {
      let seconds = i * 1800;
      let time = DateTime.secondsToTime(seconds);
      let value = time.hours + ':' + time.minutes;
      result.push({
        code: value,
        name: "_" + i,
        label: value,
        value: value,
      })
    }

    return result;
  },
  fromNow: (datetime) => {
    var langCode = Browser.getLanguageCode();
    var target = moment(datetime).locale(langCode);

    return target.fromNow();
  },
  secondsDuration: (startDatetime, endDatetime) => {
    if (!startDatetime || !endDatetime) { return 0; }

    var momentStart = moment(new Date(startDatetime));
    var momentEnd = moment(new Date(endDatetime));
    var duration = moment.duration(momentEnd.diff(momentStart));

    return duration.asSeconds();
  },
  timeDuration: (startDatetime, endDatetime) => {
    var secondsDuration = DateTime.secondsDuration(startDatetime, endDatetime);

    return DateTime.secondsToTime(secondsDuration).shortLabel;
  },
  getMinDateOfBirth: () => {
    return DateTime.addYears(new Date(), -100);
  },
  getMaxDateOfBirth: () => {
    return new Date();
  },
};

export const Request = {
  makeFormDataPayload: (payload) => {
    var formData = new FormData();
    Object.keys(payload).forEach((key) => {
      let value = payload[key];
      if (Array.isArray(value)) {
        value.forEach(x => {
          if (x instanceof File) {
            formData.append(key, x);
          }
          else if (!Objecter.isObject(x)) {
            formData.append(key + '[]', x);
          }
        })
      }
      else if (value instanceof Date) {
        formData.append(key, DateTime.format(value, 'yyyy-MM-dd HH:mm:ss'));
      }
      else if (value instanceof File) {
        formData.append(key, value);
      }
      else if (!Objecter.isObject(value)) {
        formData.append(key, value)
      }
    });
    formData.append('___make_by_form_data', true);
    return formData;
  },
  convertToFormBool: (value) => {
    if (value === true) { return 1; }
    if (value === false) { return 0; }
    return value;
  },
  makeJsonPayload: (payload) => {
    Object.keys(payload).forEach((key) => {
      let value = payload[key];
      if (value instanceof Date) {
        payload[key] = DateTime.format(value, 'yyyy-MM-dd HH:mm:ss');
      }
    });
    return JSON.stringify(payload);
  },
  makeRequestCall: async (method, url, payload = {}) => {
    const authUser = Auths.getUser();
    let bearerAccessToken = payload.bearerAccessToken ? payload.bearerAccessToken : Auths.getBearerAccessToken();
    if (bearerAccessToken === Auths.noTokenValue && authUser) {
      bearerAccessToken = await Request.loadAccessToken();
    }
    let headers = {
      'Access-Control-Allow-Origin': process.env.REACT_APP_CORS_ORIGIN,
      'Access-Control-Allow-Credentials': true,
    };
    if (!payload.useFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const requestAdapter = payload.useSkippedRequest ? skippedRequest : request;
    const requestUrl = payload.useRawUrl ? url : Request.getUrl(url, payload.query);
    const requestHeaders = headers;
    let response = null;

    switch (method.toUpperCase()) {
      case 'GET':
        response = await requestAdapter(requestUrl, {
          method: method,
          headers: requestHeaders,
        })
        break;
      default:
        const requestBody = payload.useFormData ?
          Request.makeFormDataPayload(payload.body) :
          Request.makeJsonPayload(payload.body);
        response = await requestAdapter(requestUrl, {
          method: method,
          headers: requestHeaders,
          body: requestBody,
        })
        break;
    }

    response = Transcription.transcribeResponse(response);

    return response;
  },
  loadAccessToken: async () => {
    try {
      const requestURL = process.env.REACT_APP_API_ENDPOINT + 'auth/access-token';
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      };
      const payload = await request(requestURL, requestOptions);
      if (payload.result) {
        // return new token
        const accesstoken = payload.data.token;
        Auths.setAccessToken(accesstoken);
        return Auths.makeBearerToken(accesstoken);
      }
      Auths.removeTokens();
      Auths.removeUser();
      return Auths.noTokenValue;
    }
    catch (e) {
      console.error(e);
      Auths.removeTokens();
      Auths.removeUser();
      return Auths.noTokenValue;
    }
  },
  getCsrfToken: async () => {
    const requestURL = process.env.REACT_APP_API_ENDPOINT + 'auth/csrf';
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    };
    const payload = await request(requestURL, requestOptions);
    return payload.result ? payload.data.csrf_token : 'notset';
  },
  getUrl: (endpoint, request) => {
    if (!request) {
      return process.env.REACT_APP_API_ENDPOINT + endpoint;
    }

    var pagingString = !Stringer.isEmpty(request.page) ?
      'page=' + Number(request.page + 1) : '';
    var sortString = !Stringer.isEmpty(request.sortOrder) ?
      'sort=' + request.sortOrder.name +
      '&direction=' + request.sortOrder.direction : '';
    var limitString = !Stringer.isEmpty(request.limit) ?
      'limit=' + Number(request.limit) : '';

    var filterString = '';
    var filterList = request.filterList ? request.filterList : [];
    filterList.forEach(function (item, index) {
      if (item.length !== 0) {
        filterString += index === 0 ? '' : '&';
        filterString += 'filter_' + request.columns[index].name + '=' + item[0];
      }
    });

    if (pagingString === '' && sortString === '' && limitString === '' && filterString === '') {
      return process.env.REACT_APP_API_ENDPOINT + endpoint;
    }

    return process.env.REACT_APP_API_ENDPOINT + endpoint + '?' + pagingString + sortString + limitString + filterString;
  }
};

export const Response = {
  isValidatorFailed: (fieldName, alert) => {
    if (!alert) {
      return false;
    }
    if (alert.type !== "validate") {
      return false;
    }

    var isInvalid = false;
    Object.keys(alert.validators).forEach(function (key) {
      if (key === fieldName) {
        isInvalid = true;
      }
    });

    return isInvalid;
  },
  validateFieldName: (fieldName, alert) => {
    if (!alert) return false;
    if (alert.type !== "validation") return false;

    let isInvalid = false;
    let message = '';
    if (alert.validationMessages) {
      for (const x of alert.validationMessages) {
        for (const y of x.path) {
          if (y === fieldName) {
            isInvalid = true;
          }
        }
        message = x.message;
      }
    }

    return {
      isInvalid: isInvalid,
      message: message
    };
  },
};

export const Stringer = {
  isEmpty: (obj) => {
    if (!obj) {
      return true;
    }
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  },
  makeAbbreviation: (value, digits = 1) => {
    var number = Numberer.isFloat(value) ? Math.round(value) : value;

    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function (item) {
      return number >= item.value;
    });
    return item ? (number / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : number;
  },
  applyMask: (str, mask) => {
    if (!str || !mask) { return ''; }

    let i = 0;
    return mask.replaceAll("#", () => str[i++] || "");
  },
  substringBetween: (str, start, end) => {
    return str.split(start).pop().split(end)[0];
  },
  convertToHalfWidth: (str) => {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  },
  stripNonNumeric: (str) => {
    return str.replace(/\D/g, '');
  },
  containsJapaneseCharacters: (str) => {
    const pattern = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/
    // -------------_____________-------------_____________-------------_____________
    // Punctuation   Hiragana     Katakana    Full-width       CJK      CJK Ext. A
    //                                          Roman/      (Common &      (Rare)    
    //                                        Half-width    Uncommon)
    //                                         Katakana

    return pattern.test(str);
  },
  sanitize: (dirtyHtml) => {
    return DOMPurify.sanitize(dirtyHtml, {
      ADD_ATTR: ['target']
    });
  },
};

export const Numberer = {
  isFloat: (n) => {
    return Number(n) === n && n % 1 !== 0;
  },
  thousandSeparator: (number) => {
    if (number) {
      number = Number(number);
      return (number).toLocaleString('en');
    }

    return number;
  },
  makeCurrency: (amount, prefix, suffix) => {
    var result = Numberer.thousandSeparator(amount);

    if (prefix) {
      result = prefix + result;
    }
    if (suffix) {
      result = result + suffix;
    }

    return result;
  },
  isNumeric: (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  },
  convertToNumeric: (str) => {
    var result = '';
    var raw = str.normalize('NFKC');
    for (var i = 0; i < raw.length; i++) {
      if (Numberer.isNumeric(raw[i])) {
        result += raw[i];
      }
    }

    return result;
  },
  randomInteger: (start, end) => {
    var range = end - start + 1;
    var randomValue = Math.floor(Math.random() * range) + start;
    return randomValue;
  },
};

export const Arrayer = {
  isArray: (value) => {
    return value instanceof Array;
  },
  removeElement: (arr, id) => {
    for (var i = 0; i < arr.length; i++) {

      if (arr[i].id === id || arr[i] === id) {
        arr.splice(i, 1);
      }
    }

    return arr;
  },
  groupBy: (arr, property) => {
    return arr.reduce(function (memo, x) {
      if (!memo[x[property]]) { memo[x[property]] = []; }
      memo[x[property]].push(x);
      return memo;
    }, {});
  },
  distinct: (arr, key) => {
    return [...new Map(arr.map(item =>
      [item[key], item])).values()];
  },
  intersection: (arr1, arr2) => {
    return arr1.filter(value => arr2.includes(value));
  },
  makeByRange: (size, startAt = 0) => {
    return [...Array(size).keys()].map(i => i + startAt);
  },
  distinctMergeObjectArray: (arrA, arrB, idField = 'id') => {
    var ids = new Set(arrA.map(x => x[idField]));
    var merged = [...arrA, ...arrB.filter(x => !ids.has(x[idField]))];
    return merged;
  }
};

export const Objecter = {
  isObject: (value) => {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
  },
  assignWithInterface: (pattern, data, newData) => {
    var patternAndData = Object.assign(pattern, data);
    var dataAndNewData = Object.assign(data, newData);
    var result = Object.assign(patternAndData, dataAndNewData);
    var matchedKeyCount = 0;
    var unmatchingKeyCount = 0;

    Object.keys(dataAndNewData).forEach(function (dataKey) {
      if (Object.keys(pattern).includes(dataKey)) {
        matchedKeyCount++;
      }
      else {
        unmatchingKeyCount++;
      }
    });

    if (
      (Object.keys(data).length !== 0 && matchedKeyCount < 1) ||
      unmatchingKeyCount > 0
    ) {
      console.log('matchedKeyCount: ', matchedKeyCount);
      console.log('unmatchingKeyCount: ', unmatchingKeyCount);
      return new Error('Interface did not matched');
    }

    return result;
  },
};

export const Formik = {
  fillFormData: (initialValues, formData) => {
    Object.keys(initialValues).forEach(function (key) {
      initialValues[key] = formData.hasOwnProperty(key) ? formData[key] : initialValues[key];
    });

    return initialValues;
  },
  makeInitialValues: (defaultValues, data) => {
    if (!data) return defaultValues;

    var initialValues = {};
    Object.keys(defaultValues).forEach((key) => {
      initialValues[key] = data.hasOwnProperty(key) ? data[key] : defaultValues[key];
    });

    return initialValues;
  },
  makeAdapterFieldValues: (name, data, splittedNames) => {
    var result = {};
    result[name] = data ? data : [];

    if (data) {
      data.forEach((x, index) => {
        if (splittedNames && splittedNames?.length > 0) {
          splittedNames.forEach((y) => {
            result[name + '_' + y + '_' + index] = x[y];
          });
        }
        else {
          result[name + '_' + index] = x;
        }
      });
    }

    return result;
  },
  makeListFieldValues: (name, data, splittedNames) => {
    var result = {};
    result[name] = data ? data : [];

    if (data) {
      data.forEach((x, index) => {
        if (splittedNames && splittedNames?.length > 0) {
          splittedNames.forEach((y) => {
            result[name + '_' + y + '_' + index] = x[y];
          });
        }
        else {
          result[name + '_' + index] = x;
        }
      });
    }

    return result;
  },
  makeSubFieldValues: (name, data, splittedNames) => {
    var result = {};
    var validSubCount = 0;
    result[name] = "";

    splittedNames.forEach((x) => {
      let value = data[name + '_' + x]
      result[name] += value;
      result[name + '_' + x] = value;

      if (value) { validSubCount++ }
    });

    if (validSubCount < splittedNames.length) {
      result[name] = "";
    }

    return result;
  },
};

export const Filer = {
  formatFileSize: (bytes, decimals = 2, useBinary = true) => {
    // Convert string to number
    if (typeof bytes === 'string') {
      bytes = parseFloat(bytes);
    }

    if (isNaN(bytes) || bytes === 0) return { value: '0', unit: 'Bytes', reducedBy: 0, reducedBytes: 0 };

    const k = useBinary ? 1024 : 1000; // base for calculation
    const dm = decimals < 0 ? 0 : decimals; // ensure decimals is non-negative
    const sizes = useBinary
      ? ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB'] // binary units
      : ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];      // decimal/SI units

    const i = Math.floor(Math.log(bytes) / Math.log(k)); // determine the unit index
    const size = bytes / Math.pow(k, i);                // calculate the value in the chosen unit
    return {
      integerValue: size.toFixed(0),
      value: size.toFixed(dm),
      unit: sizes[i] ? sizes[i] : useBinary ? 'EiB' : 'EB',
      reducedBy: i,
      reducedBytes: Math.pow(k, i),
    };
  },
  getFormatFileSizeLabel: (bytes, decimals = 2, useBinary = true) => {
    const { value, unit } = Filer.formatFileSize(bytes, decimals, useBinary);
    return `${value} ${unit}`;
  },
  getFileTypeCode: (file) => {
    const type = file instanceof File ? file.type : file.fileTypeCode;
    if (!type) return Constants.File.FileType.Other.code;
    if (type.startsWith("image")) {
      return Constants.File.FileType.Image.code;
    } else if (type.startsWith("video")) {
      return Constants.File.FileType.Video.code;
    } else if (type.startsWith("audio")) {
      return Constants.File.FileType.Audio.code;
    } else {
      return Constants.File.FileType.Other.code;
    }
  },
  blobToFile: (theBlob, fileName) => {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  },
  dataUriToBlob: (dataURI) => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    //Old Code
    //write the ArrayBuffer to a blob, and you're done
    //var bb = new BlobBuilder();
    //bb.append(ab);
    //return bb.getBlob(mimeString);

    //New Code
    return new Blob([ab], { type: mimeString });
  },
  dataUriToFile: (dataUri, fileName) => {
    var theBlob = Filer.dataUriToBlob(dataUri);

    return Filer.blobToFile(theBlob, fileName);
  },
  generateFileName: (originalFileName, requestType) => {
    var date = new Date();
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).slice(-2);
    var day = ('0' + date.getDate()).slice(-2);
    var hour = ('0' + date.getHours()).slice(-2);
    var minutes = ('0' + date.getMinutes()).slice(-2);
    var secconds = ('0' + date.getSeconds()).slice(-2);
    var uuid = uuidv4();

    if (originalFileName) {
      var nameFragment = originalFileName.split('.');
      var type = nameFragment[nameFragment.length - 1]

      return year + '-' + month + '-' + day + '_' +
        hour + '-' + minutes + '-' + secconds + '_' + uuid + '.' + type;
    }

    if (requestType) {
      return year + '-' + month + '-' + day + '_' +
        hour + '-' + minutes + '-' + secconds + '_' + uuid + '.' + requestType;
    }

    return year + '-' + month + '-' + day + '_' +
      hour + '-' + minutes + '-' + secconds + '_' + uuid;
  },
  uploadFiles: async (roleCode, typeCode, files, refId = null) => {
    try {
      // Process all files concurrently using Promise.all
      const filePostList = await Promise.all(
        files.map(async (file) => {
          const fileTypeCode = Filer.getFileTypeCode(file); // Determine file type
          const originalSize = file.size.toString();
          let thumbnailSize = 0;
          const displayName = file.name;                   // Original file name
          const fileName = Filer.generateFileName(file.name); // Generate unique file name

          // Upload the main file
          const response = await S3.presignedUpload(roleCode, file, typeCode, fileName, originalSize);
          if (!response.result) return response; // Skip if upload failed

          // Generate thumbnail if file is an image
          let thumbnailPath = null;
          if (fileTypeCode === Constants.File.FileType.Image.code) {
            const thumbnailFile = await Filer.makeImageFileThumbnail(file); // Resize image
            thumbnailSize = thumbnailFile.size.toString();
            const thumbnailFileName = `thumbnail-${fileName}`;
            const thumbnailResponse = await S3.presignedUpload(
              roleCode,
              thumbnailFile,
              typeCode,
              thumbnailFileName,
              thumbnailSize,
            );
            if (thumbnailResponse.result) {
              thumbnailPath = thumbnailResponse.data.key; // Save thumbnail path
            }
          }
          else {
            thumbnailSize = "0";
          }

          // Return structured file info
          return {
            result: true,
            data: {
              typeCode,
              fileTypeCode,
              originalSize,
              thumbnailSize,
              refId,
              path: response.data.key,
              thumbnailPath,
              fileName,
              fileFormat: fileName.split('.').pop(), // Extract file extension
              displayName,
            }
          };
        })
      );

      // Send the list of uploaded files to the server
      const successfulFiles = filePostList.filter(x => x.result).map(x => x.data);
      let response = await Request.makeRequestCall(
        'POST',
        `${roleCode}/files/${roleCode !== Constants.User.Role.Admin.code ? typeCode : ''}`,
        {
          body: { postList: successfulFiles }
        }
      );

      // handle failed responses
      const failedResponses = filePostList.filter(x => !x.result);
      if (failedResponses.length > 0) {
        return failedResponses[0]
      }

      return response;
    } catch (e) {
      console.log('Error', e);
      return [];
    }
  },
  makeAdapterFile: (file) => {
    let pathShards = [];
    let adapter = {
      fileTypeCode: Filer.getFileTypeCode(file),
      fileName: null,
      fileFormat: null,
      displayName: null,
      path: null,
      thumbnailPath: null,
      url: null,
      urlExpiresAt: null,
      thumbnailUrl: null,
      thumbnailUrlExpiresAt: null,
    }
    if (file instanceof File) { // File
      pathShards = file.type.split('/');
      adapter.fileFormat = pathShards[pathShards.length - 1];
      adapter.fileName = file.name;
      adapter.displayName = file.name;
      adapter.url = URL.createObjectURL(file);
      adapter.thumbnailUrl = adapter.url;
    }
    else if (Objecter.isObject(file)) { // File data
      if (!file.fileName) {
        throw new TypeError('invalid fileName');
      }
      pathShards = file.fileName.split('.');
      adapter.fileFormat = pathShards[pathShards.length - 1];
      adapter.fileName = file.fileName;
      adapter.displayName = file.displayName;
      adapter.url = file.url;
      adapter.thumbnailUrl = file.thumbnailUrl;
      adapter.path = file.path;
      adapter.thumbnailPath = file.thumbnailPath;
      adapter.urlExpiresAt = file.urlExpiresAt;
      adapter.thumbnailUrlExpiresAt = file.thumbnailUrlExpiresAt;
    }
    else {
      throw new TypeError('invalid file');
    }

    file.adapter = adapter;
    return file;
  },
  makeAdapterFiles: (files) => {
    return files.map((x, index) => {
      const newX = Filer.makeAdapterFile(x);
      if (newX instanceof File) { return newX; }

      let rows = 1, cols = 1;
      if (index === 0 || index === 3) {
        cols = 2;
        rows = 2;
      }

      newX.adapter.galleryCols = cols;
      newX.adapter.galleryRows = rows;
      return newX;
    });
  },
  async makeCropUrl(presignedUrl, targetWidth, targetHeight) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = presignedUrl;

    await img.decode();

    const srcCanvas = document.createElement('canvas');
    srcCanvas.width = img.width;
    srcCanvas.height = img.height;
    srcCanvas.getContext('2d').drawImage(img, 0, 0);

    const dstCanvas = document.createElement('canvas');
    dstCanvas.width = targetWidth;
    dstCanvas.height = targetHeight;

    const picaInstance = pica();
    await picaInstance.resize(srcCanvas, dstCanvas, { alpha: true });

    return new Promise(resolve => {
      dstCanvas.toBlob(blob => resolve(URL.createObjectURL(blob)), 'image/png');
    });
  },
  async makeImageFileThumbnail(file, options = { maxWidth: 300, quality: 0.3, fixedWidth: null, fixedHeight: null }) {
    const { maxWidth, quality, fixedWidth, fixedHeight } = options;

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = async () => {
        try {
          const canvasInput = document.createElement("canvas");
          canvasInput.width = img.width;
          canvasInput.height = img.height;
          canvasInput.getContext("2d").drawImage(img, 0, 0);

          let width, height;
          if (fixedWidth && fixedHeight) {
            width = fixedWidth;
            height = fixedHeight;
          } else {
            const scale = Math.min(1, maxWidth / img.width);
            width = Math.round(img.width * scale);
            height = Math.round(img.height * scale);
          }

          const canvasOutput = document.createElement("canvas");
          canvasOutput.width = width;
          canvasOutput.height = height;

          await pica().resize(canvasInput, canvasOutput);
          const blob = await pica().toBlob(canvasOutput, file.type, quality);

          resolve(Filer.blobToFile(blob, `thumbnail-${file.name}`));
        } catch (err) {
          reject(err);
        }
      };

      img.onerror = reject;
    });
  }
};

export const Browser = {
  getUrlSearchParam: (name) => {
    const params = new URLSearchParams(window.location.search);

    if (!params.has(name)) {
      return false;
    }

    const result = Numberer.isNumeric(params.get(name)) ? Number(params.get(name)) : params.get(name);

    return result;
  },
  makeUrlSearchParams: (payload) => {
    if (!payload) return '';
    const cloned = { ...payload };

    Object.keys(payload).forEach(function (key) {
      const item = payload[key];
      if (Array.isArray(item)) {
        cloned[key] = item.toString();
      }
      if (item instanceof Date) {
        cloned[key] = item.toISOString();
      }
      if (item === null || item === undefined) {
        delete cloned[key];
      }
    });

    return new URLSearchParams(cloned).toString();
  },
  getLocationUrl: () => {
    const href = window.location.href;
    const parts = href.split('//')[1].split('/');

    return window.location.protocol + '//' + parts[0];
  },
  isMobileDevice: () => {
    return window.screen.width < 800;
  },
  getLanguageCode: () => {
    const i18Code = localStorage.getItem("i18nextLng");
    const langList = General.getConstant(Constants.General.Nation).list;
    const codeExisting = langList.some(item => item.code === i18Code);
    const defaultCode = process.env.REACT_APP_DEFAULT_LANGUAGE_CODE;
    return codeExisting ? i18Code : defaultCode;
  },
  isFullscreen: (element) => {
    return (
      (document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement) === element
    );
  },
  requestFullscreen: (element) => {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullScreen) {
      element.webkitRequestFullScreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullScreen) {
      element.msRequestFullScreen();
    }
  },
  exitFullscreen: () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  },
  getTabTitle: (key) => {
    return `${Constants.General.Env.companyName}・${i18n.t(`${key}.title`)}`;
  },
  initializeVideoStream: async (playerKey, facingMode) => {
    return new Promise((resolve, reject) => {
      const player = document.getElementById(playerKey);

      navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: facingMode,
        }
      }).then(function (stream) {
        player.srcObject = stream;
        player.setAttribute('playsinline', true);
        player.play();
        resolve({
          stream: stream,
          player: player
        });
      });
    });
  },
  initializeAudioStream: async () => {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices.getUserMedia({
        audio: {
          sampleSize: 16,
          channelCount: 1,
          sampleRate: 48000
        }
      }).then(function (stream) {
        const recorder = new MediaRecorder(stream);

        resolve({
          stream: stream,
          recorder: recorder
        });
      });
    });
  },
  initializeQrScannerStream: async (canvasKey, onResultCallback) => {
    const video = document.createElement('video');
    const canvasElement = document.getElementById(canvasKey);
    const canvas = canvasElement.getContext('2d');

    const tick = () => {
      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvasElement.height = video.videoHeight;
        canvasElement.width = video.videoWidth;
        canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
        var imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
        var code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'dontInvert'
        });

        if (code) {
          onResultCallback(code.data);
        }
      }

      requestAnimationFrame(tick);
    };

    return new Promise((resolve, reject) => {
      navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: 'environment'
        }
      }).then(function (stream) {
        video.srcObject = stream;
        video.setAttribute('playsinline', true);
        video.play();
        requestAnimationFrame(tick);

        resolve({
          stream: stream,
          video: video
        });
      });
    });
  },
  initializeCurrentPosition: async (enableLog) => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(({ coords: { latitude: lat, longitude: lng } }) => {
        const pos = { lat, lng };
        if (enableLog) {
          console.log('Detected coords:', pos);
        }
        resolve(pos);
      })
    });
  },
  getChartSize: () => {
    var windowWidth = window.screen.width;
    var width = 800;
    var height = 350;
    var halfWidth = 400;
    var halfHeight = 200;
    if (windowWidth > 1000) {
      width = 800;
      height = 350;
      halfWidth = 400;
      halfHeight = 200;
    }
    if (windowWidth <= 1000 && windowWidth > 850) {
      width = 600;
      height = 300;
      halfWidth = 300;
      halfHeight = 150;
    }
    if (windowWidth <= 850 && windowWidth > 600) {
      width = 500;
      height = 250;
      halfWidth = 250;
      halfHeight = 150;
    }
    if (windowWidth <= 600 && windowWidth > 400) {
      width = 500;
      height = 200;
      halfWidth = 250;
      halfHeight = 100;
    }
    if (windowWidth <= 400) {
      width = 300;
      height = 200;
      halfWidth = 250;
      halfHeight = 100;
    }
    return {
      width: width,
      height: height,
      halfWidth: halfWidth,
      halfHeight: halfHeight,
    };
  },
  copyToClipboard: async (text) => {
    // Modern API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        console.log('Copied to clipboard using Clipboard API', text);
        return true;
      } catch (err) {
        console.warn('Clipboard API failed, fallback to execCommand:', err);
      }
    }

    // Fallback (textarea + execCommand)
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);

      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length); // support mobile

      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      console.log('Copied to clipboard using fallback', text);
      return success;
    } catch (err) {
      console.error('Fallback copy failed:', err);
      return false;
    }
  },
};

export const GoogleMap = {
  getMaps: () => {
    // warning: wrap component in @googlemaps/react-wrapper first
    return window.google.maps;
  },
  fetchReverseGeocode: async (lat, lng) => {
    const searchParams = Browser.makeUrlSearchParams({
      language: Browser.getLanguageCode(),
      location_lat: lat,
      location_lng: lng,
    });
    const response = await Request.makeRequestCall(
      'GET',
      'google-maps/reverse-geocode?' + searchParams,
    )

    if (response.result) {
      return response.data;
    }
    return {};
  },
  getMapCenterPosition: (map) => {
    return {
      lat: map.getCenter().lat(),
      lng: map.getCenter().lng(),
    };
  },
  mapGeocode: async (maps, payload) => {
    // https://developers.google.com/maps/documentation/javascript/geocoding
    const geocoder = new maps.Geocoder();

    return new Promise((resolve) => geocoder.geocode(payload, (results, status) => {
      if (status === 'OK') {
        var result = results[0];
        var countryComponent = result.address_components.filter(item => item.types.includes('country'))[0];
        var country = countryComponent ? countryComponent.long_name : '';
        result.sliced_formatted_address = result.formatted_address.replace(country + '、', '');
        resolve(result);
      }
      else {
        console.log('Geocode was not successful for the following reason: ' + status);
        resolve({});
      }
    }))
  },
  makeMarkerIcon: (fillColor, fillOpacity) => {
    // https://developers.google.com/maps/documentation/javascript/examples/marker-modern
    // https://developers.google.com/maps/documentation/javascript/custom-markers
    // https://stackoverflow.com/questions/37441729/google-maps-custom-label-x-and-y-position
    // https://stackoverflow.com/questions/33321440/google-maps-api-add-custom-svg-marker-with-label

    return {
      path: `M13.04,41.77c-0.11-1.29-0.35-3.2-0.99-5.42c-0.91-3.17-4.74-9.54-5.49-10.79c-3.64-6.1-5.46-9.21-5.45-12.07
      c0.03-4.57,2.77-7.72,3.21-8.22c0.52-0.58,4.12-4.47,9.8-4.17c4.73,0.24,7.67,3.23,8.45,4.07c0.47,0.51,3.22,3.61,3.31,8.11
      c0.06,3.01-1.89,6.26-5.78,12.77c-0.18,0.3-4.15,6.95-5.1,10.26c-0.64,2.24-0.89,4.17-1,5.48C13.68,41.78,13.36,41.78,13.04,41.77z
      `,
      fillColor: fillColor ? fillColor : '#ff0000',
      fillOpacity: fillOpacity ? fillOpacity : 1,
      strokeColor: '#ffffff',
      strokeWeight: 1,
      anchor: {
        x: 27 / 2, // width / 2
        y: 43, // height
      },
      labelOrigin: {
        x: 13.5,
        y: 15
      },
    };
  },
  makeMarkerLabel: (text, color, fontSize) => {
    return {
      text: text ? text : 'M',
      color: color ? color : "#fff",
      fontSize: fontSize ? fontSize : "10px"
    };
  },
  makeDisplayCoordinate: (lat, lng) => {
    return '@' + lat + ',' + lng + ',15z';
  },
  makeCoordinateUrl: (lat, lng) => {
    var displayCoordinate = GoogleMap.makeDisplayCoordinate(lat, lng);
    return `${process.env.REACT_APP_GOOGLE_MAPS_COORDINATE_SEARCH_ENDPOINT}/${lat},${lng}/${displayCoordinate}`;
  },
  makeInfoWindow: (maps, map, payload) => {
    const makeElement = (payload) => {
      const div = document.createElement('div');
      div.setAttribute("class", "info-window map-child");
      // info
      const infoDiv = document.createElement('div');
      infoDiv.setAttribute("class", "info map-child");
      if (payload.name) {
        const nameDiv = document.createElement('div');
        nameDiv.setAttribute("class", "name map-child");
        nameDiv.innerHTML = payload.name;
        infoDiv.append(nameDiv);
      }
      if (payload.address) {
        const addressDiv = document.createElement('div');
        addressDiv.setAttribute("class", "address map-child");
        addressDiv.innerHTML = payload.address;
        infoDiv.append(addressDiv);
      }
      div.append(infoDiv);

      // actions
      const actionsDiv = document.createElement('div');
      actionsDiv.setAttribute("class", "actions map-child");
      if (payload.direction) {
        const directionIcon = document.createElement('span');
        directionIcon.setAttribute("class", "direction action-icon material-icons map-child");
        directionIcon.innerHTML = "directions";
        directionIcon.addEventListener("click", () => {
          window.open(GoogleMap.makeCoordinateUrl(payload.location_lat, payload.location_lng), '_blank');
        });
        actionsDiv.append(directionIcon);
      }
      if (payload.readCallback) {
        const readIcon = document.createElement('span');
        readIcon.setAttribute("class", "read action-icon material-icons map-child");
        readIcon.innerHTML = "info";
        readIcon.addEventListener("click", payload.readCallback);
        actionsDiv.append(readIcon);
      }
      if (payload.createCallback) {
        const createIcon = document.createElement('span');
        createIcon.setAttribute("class", "create action-icon material-icons map-child");
        createIcon.innerHTML = "add_circle";
        createIcon.addEventListener("click", payload.createCallback);
        actionsDiv.append(createIcon);
      }

      div.append(actionsDiv);
      return div;
    };

    const infoWindow = new maps.InfoWindow({
      content: makeElement(payload),
    });

    infoWindow.setContentElement = (payload) => {
      infoWindow.setContent(makeElement(payload));
    };

    return infoWindow;
  },
  makePointMarker: (maps, map, payload) => {
    var marker = new maps.Marker({
      position: {
        lat: payload.location_lat,
        lng: payload.location_lng,
      },
      draggable: payload.draggable,
      animation: payload.animation, // maps.Animation.DROP
      icon: payload.icon,
      label: payload.label,
    });

    marker.addListener("click", () => {
      if (payload.infoWindow) {
        payload.infoWindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        });
      }
    });
    // default open
    if (payload.infoWindow && payload.openInfoWindow) {
      payload.infoWindow.open(map, marker);
    }
    if (payload.draggable) {
      marker.addListener('dragend', (event) => {
        payload.dragendCallback({
          location_lat: event.latLng.lat(),
          location_lng: event.latLng.lng(),
        })
      });
    }

    return marker;
  },
  initializeMapSearchBox: (maps, map) => {
    const existingElement = document.querySelector('.GoogleMap .search-box');
    if (existingElement || !maps || !map) { return false; }

    const input = document.createElement('input');
    input.setAttribute("type", "text");
    input.setAttribute("class", "search-box");
    const searchBox = new maps.places.SearchBox(input);
    map.controls[maps.ControlPosition.TOP_CENTER].push(input);
    map.addListener("bounds_changed", () => {
      // searchBox.setBounds(map.getBounds());
    });
    searchBox.addListener("places_changed", () => {
      const places = searchBox.getPlaces();
      if (places.length === 0) {
        return;
      }
      // For each place, get the icon, name and location.
      const bounds = new maps.LatLngBounds();

      places.forEach((place) => {
        if (!place.geometry || !place.geometry.location) {
          console.log("Returned place contains no geometry");
          return;
        }
        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
          map.setCenter(place.geometry.location);
          map.setZoom(15);
        }
      });
      map.fitBounds(bounds);
    });
  },
  initializeMapCurrentAnchor: async (maps, map) => {
    const existingElement = document.querySelector('.GoogleMap .current-anchor');
    if (existingElement || !maps || !map) { return false; }

    // create button
    const button = document.createElement('div');
    button.setAttribute("class", "map-child map-button current-anchor");
    const icon = document.createElement('span');
    icon.setAttribute("class", "map-child icon material-icons");
    icon.innerHTML = "my_location";
    button.append(icon);
    button.addEventListener("click", async () => {
      const currentPosition = await Browser.initializeCurrentPosition();
      map.setCenter(currentPosition);
      map.setZoom(15);
    });

    map.controls[maps.ControlPosition.RIGHT_CENTER].push(button);
  },
  initializeMapTypeControl: async (maps, map) => {
    const existingElement = document.querySelector('.GoogleMap .map-type-control');
    if (existingElement || !maps || !map) { return false; }

    // create button
    const button = document.createElement('div');
    button.setAttribute("class", "map-child map-button map-type-control");
    const icon = document.createElement('span');
    icon.setAttribute("class", "map-child icon material-icons");
    button.append(icon);
    button.addEventListener("click", async () => {
      if (map.mapTypeId === Constants.GoogleMap.MapType.Roadmap.code) {
        map.setOptions({ mapTypeId: Constants.GoogleMap.MapType.Hybrid.code });
        icon.innerHTML = "satellite";
      }
      else if (map.mapTypeId === Constants.GoogleMap.MapType.Hybrid.code) {
        map.setOptions({ mapTypeId: Constants.GoogleMap.MapType.Satellite.code });
        icon.innerHTML = "satellite_alt";
      }
      else {
        map.setOptions({ mapTypeId: Constants.GoogleMap.MapType.Roadmap.code });
        icon.innerHTML = "map";
      }
    });

    if (map.mapTypeId === Constants.GoogleMap.MapType.Roadmap.code) {
      icon.innerHTML = "map";
    }
    else if (map.mapTypeId === Constants.GoogleMap.MapType.Hybrid.code) {
      icon.innerHTML = "satellite";
    }
    else {
      map.setOptions({ mapTypeId: Constants.GoogleMap.MapType.Roadmap.code });
      icon.innerHTML = "satellite_alt";
    }
    map.controls[maps.ControlPosition.RIGHT_CENTER].push(button);
  },
  initializeMapFullscreenControl: async (maps, map) => {
    const existingElement = document.querySelector('.GoogleMap .map-full-screen-control');
    if (existingElement || !maps || !map) { return false; }

    const elementToSendFullscreen = map.getDiv().firstChild;
    // create button
    const button = document.createElement('div');
    button.setAttribute("class", "map-child map-button map-full-screen-control");
    const icon = document.createElement('span');
    icon.setAttribute("class", "map-child icon material-icons");
    icon.innerHTML = "fullscreen";
    button.append(icon);
    button.addEventListener("click", async () => {
      if (Browser.isFullscreen(elementToSendFullscreen)) {
        Browser.exitFullscreen();
        icon.innerHTML = "fullscreen";
      } else {
        Browser.requestFullscreen(elementToSendFullscreen);
        icon.innerHTML = "fullscreen_exit";
      }
    });

    map.controls[maps.ControlPosition.RIGHT_CENTER].push(button);
  },
  initializeMapSearchBar: (maps, map, payload) => {
    const existingBar = document.querySelector('.GoogleMap .search-bar');
    const existingResult = document.querySelector('.GoogleMap .search-result');
    if (!maps || !map) { return false; }
    if (existingBar) { existingBar.remove(); }
    if (existingResult) { existingResult.remove(); }

    // result
    const searchResult = document.createElement('div');
    searchResult.setAttribute("class", "search-result map-child");
    searchResult.setAttribute("style", "display: none;")

    const resultContainer = document.createElement('div');
    resultContainer.setAttribute("class", "result-container map-child");

    searchResult.append(resultContainer);

    // bar
    const searchBar = document.createElement('div');
    searchBar.setAttribute("class", "search-bar map-child");

    const pinIcon = document.createElement('span');
    pinIcon.setAttribute("class", "pin-icon material-icons map-child");
    pinIcon.innerHTML = "place";
    pinIcon.addEventListener("click", (e) => {
      let input = document.querySelector('.GoogleMap .search-bar-input');
      input.focus();
    });

    const backIcon = document.createElement('span');
    backIcon.setAttribute("class", "back-icon material-icons map-child");
    backIcon.innerHTML = "arrow_back";
    backIcon.addEventListener("click", (e) => {
      let input = document.querySelector('.GoogleMap .search-bar-input');
      input.blur();
    });
    backIcon.setAttribute("style", "display: none;");

    // submit
    const handleOnSubmit = async (e) => {
      e.preventDefault(); // stop form refreshing page on submit

      let input = document.querySelector('.GoogleMap .search-bar-input');
      let value = input.value;
      let resultItems = await payload.onInputChangeCallback(value);
      let currentResultContainer = document.querySelector('.GoogleMap .search-result .result-container');
      if (currentResultContainer) { currentResultContainer.innerHTML = ""; }

      for (const x of resultItems) {
        let item = document.createElement('div');
        item.setAttribute("class", "result-item map-child");
        item.addEventListener("click", x.callback);

        let icon = document.createElement('div');
        icon.setAttribute("class", "icon material-icons map-child");
        icon.innerHTML = x.icon;

        let content = document.createElement('div');
        content.setAttribute("class", "content map-child");

        let title = document.createElement('div');
        title.setAttribute("class", "title dot-overflow map-child");
        title.innerHTML = x.title;

        let address = document.createElement('div');
        address.setAttribute("class", "address dot-overflow map-child");
        address.innerHTML = x.address;

        content.append(title);
        content.append(address);
        item.append(icon);
        item.append(content);
        resultContainer.append(item);
      }

      input.focus();
    };

    const searchDiv = document.createElement('div');
    searchDiv.setAttribute("class", "search-div map-child");
    searchDiv.addEventListener("click", handleOnSubmit);
    const searchIcon = document.createElement('span');
    searchIcon.innerHTML = "search";
    searchIcon.setAttribute("class", "map-child search-icon material-icons");
    searchIcon.setAttribute("type", "");
    searchDiv.append(searchIcon);

    const input = document.createElement('input');
    input.setAttribute("class", "search-bar-input map-child");
    input.setAttribute("type", "text");
    input.setAttribute("placeholder", payload?.placeholder ? payload?.placeholder : "search...");
    input.addEventListener("focus", (e) => {
      searchResult.setAttribute("style", "display: inherit;");
      pinIcon.setAttribute("style", "display: none;");
      backIcon.setAttribute("style", "display: inherit;");
    });
    input.addEventListener("blur", (e) => {
      searchResult.setAttribute("style", "display: none;");
      pinIcon.setAttribute("style", "display: inherit;");
      backIcon.setAttribute("style", "display: none;");
    });

    const searchForm = document.createElement('form');
    searchForm.setAttribute("class", "search-form map-child");
    searchForm.addEventListener("submit", handleOnSubmit);
    searchForm.append(pinIcon);
    searchForm.append(backIcon);
    searchForm.append(input);
    searchForm.append(searchDiv);

    searchBar.append(searchForm);

    map.controls[maps.ControlPosition.TOP_CENTER].push(searchBar);
    map.controls[maps.ControlPosition.TOP_LEFT].push(searchResult);
  },
  initializeMapAuthUser: (maps, map, payload) => {
    const existingElement = document.querySelector('.GoogleMap .auth-user');
    if (!maps || !map) { return false; }
    if (existingElement) { existingElement.remove(); }

    const authUserDiv = document.createElement('div');
    authUserDiv.setAttribute("class", "auth-user map-child");

    const avatarDiv = document.createElement('div');
    avatarDiv.setAttribute("class", "avatar-div map-child");
    const avatarIcon = document.createElement('span');
    avatarIcon.setAttribute("class", "map-child avatar-icon material-icons");
    avatarIcon.innerHTML = "account_circle";
    const avatarImg = document.createElement('img');
    avatarImg.setAttribute("class", "search-bar-img map-child");
    avatarImg.src = payload?.avatar_src;
    avatarImg.alt = "avatar";
    avatarImg.addEventListener('error', function handleError() {
      avatarImg.remove();
      avatarDiv.append(avatarIcon);
    });
    avatarDiv.append(avatarImg);

    authUserDiv.append(avatarDiv);

    map.controls[maps.ControlPosition.TOP_RIGHT].push(authUserDiv);
  },
  initializeMapBottomMenu: (maps, map, payload) => {
    const existingElement = document.querySelector('.GoogleMap .bottom-menu');
    if (!maps || !map) { return false; }
    if (existingElement) { existingElement.remove(); }

    const bottomMenu = document.createElement('div');
    bottomMenu.setAttribute("class", "bottom-menu map-child");

    for (const x of payload.items) {
      let menuItem = document.createElement('div');
      menuItem.setAttribute("class", "menu-item map-child");
      menuItem.addEventListener("click", x.callback);

      let icon = document.createElement('div');
      icon.setAttribute("class", "menu-item-icon icon material-icons map-child");
      icon.innerHTML = x.icon;

      let label = document.createElement('div');
      label.setAttribute("class", "menu-item-label map-child");
      label.innerHTML = x.label;

      menuItem.append(icon);
      menuItem.append(label);
      bottomMenu.append(menuItem)
    }


    map.controls[maps.ControlPosition.BOTTOM_CENTER].push(bottomMenu);
  },
};

export const WebSocketer = {
  createConnection: async (endpoint, callbacks) => {
    return new Promise(function (resolve, reject) {
      const socket = new WebSocket(endpoint);
      socket.onclose = function () {
        console.log('WebSocket has been closed!');
      };
      socket.onmessage = function (e) {
        const data = JSON.parse(e.data);
        console.log('WebSocket message received: ', data);
        if (callbacks?.onmessage) {
          callbacks.onmessage(e);
        }
      };
      socket.onopen = function () {
        console.log('WebSocket has been connected!');
        resolve(socket);
      };
      socket.onerror = function (err) {
        reject(err);
      };
    });
  },
};

export const Transcription = {
  transcribeParams: (params) => {
    var result = [];
    params.forEach((item) => {
      if (typeof item === 'string') {
        if (item.includes('date(')) {
          let dateStr = Stringer.substringBetween(item, 'date(', ')');
          let date = new Date(dateStr);
          result.push(DateTime.format(date, 'yyyy-MM-dd'));
        }
        else if (item.includes('datetime(')) {
          let dateStr = Stringer.substringBetween(item, 'datetime(', ')');
          let date = new Date(dateStr);
          result.push(DateTime.format(date, 'yyyy-MM-dd HH:mm'));
        }
        else {
          result.push(item);
        }
      }
      else {
        result.push(item);
      }
    })
    return result;
  },
  transcribeString: (plainText) => {
    var result = plainText;
    var plainTextFragment = plainText.split('___')

    if (plainTextFragment[0] === '@t') {
      var params = plainTextFragment[2] ? plainTextFragment[2].split(',') : [];
      params = Transcription.transcribeParams(params);
      result = i18n.t(plainTextFragment[1], params);
    }

    return result;
  },
  transcribeObject: (object) => {
    Object.keys(object).forEach((key) => {
      let item = object[key];

      if (typeof item === 'string') {
        object[key] = Transcription.transcribeString(item);
      }
      if (typeof item === 'object' && item) {
        object[key] = Transcription.transcribeObject(item);
      }
    });

    return object;
  },
  transcribeResponse(response) {
    if (!response || !response.data) { return response; }

    var data = response.data;
    if (typeof data === 'object' || Array.isArray(data)) {
      Object.keys(data).forEach((key) => {
        let item = data[key];

        if (typeof item === 'string') {
          data[key] = Transcription.transcribeString(item);
        }
        else if (typeof item === 'object' && item) {
          data[key] = Transcription.transcribeObject(item);
        }
      });
    }

    response.data = data;

    return response;
  },
};

export const S3 = {
  presignedUpload: async (roleCode, file, typeCode, fileName, fileSize) => {
    const fileTypeCode = Filer.getFileTypeCode(file);
    const fileType = General.getConstant(Constants.File.FileType, fileTypeCode).this;

    const response = await Request.makeRequestCall(
      'PUT',
      `${roleCode}/aws-s3/signed-url`,
      {
        body: {
          contentType: fileType.contentType,
          typeCode: typeCode,
          fileName: fileName,
          fileSize: fileSize,
        },
      }
    );

    if (response.result) {
      const headers = {
        'Content-Type': fileType.contentType,
        'Access-Control-Allow-Origin': process.env.REACT_APP_CORS_ORIGIN,
      };
      const presignedUrl = response.data.url;
      await skippedRequest(
        presignedUrl,
        {
          method: 'PUT',
          headers: headers,
          body: file,
        }
      );
    }

    return response;
  },
};

export const Route = {
  replaceParams: (routeCode, params, queryStringParameters) => {
    var result = '';
    var route = General.getConstant(Routes.Page, routeCode).this;
    if (!route.code) { return result };

    result = route.locationPath;

    if (params) {
      Object.keys(params).forEach((key) => {
        let item = params[key];

        result = result.replace(`:${key}`, item);
      });
    }

    if (queryStringParameters) {
      result += '?';
      Object.keys(queryStringParameters).forEach((key) => {
        let item = queryStringParameters[key];

        result += `${key}=${item}`
      });
    }

    return result;
  },
  getCurrentRoute: () => {
    const routes = General.getConstant(Routes.Page).list;
    const curentPathSlices = window.location.pathname.split('/');

    var route = routes.find(x => {
      var routePathSlices = x.locationPath.split('/');
      var routePathName = "";

      routePathSlices.forEach((y, yIndex) => {
        if (y.includes(':') && curentPathSlices[yIndex]) {
          routePathName += curentPathSlices[yIndex];
        }
        else {
          routePathName += y;
        }

        if (yIndex !== routePathSlices.length - 1) {
          routePathName += "/";
        }
      });

      var isMatched = routePathName === window.location.pathname;
      return x.path === '/' && window.location.pathname !== '/' ?
        false :
        isMatched;
    });

    return route;
  },
  authorizeLocationPath: (locationPath) => {
    const routes = General.getConstant(Routes.Page).list;
    var authorizeRoute = routes.find(x => x.locationPath === locationPath);
    var authUser = Auths.getUser();
    if (authorizeRoute.roleCodes.includes(authUser?.roleCode)) {
      return true;
    }
    return false;
  },
  makeMenus: (menus, authUser, navigate) => {
    var result = [];
    for (const x of menus) {
      if (!x) continue;
      x.label = i18n.t(`${x.code}.menu`);
      if (navigate) {
        x.callback = () => {
          navigate(x.locationPath);
        }
      }

      if (x.nestedItems) {
        x.nestedItems = Route.makeMenus(x.nestedItems, authUser, navigate);
      }
      if (x.roleCodes.includes(authUser?.roleCode)) {
        if (x.nestedItems) {
          if (x.nestedItems.length > 0) {
            result.push(x);
          }
        }
        else {
          result.push(x);
        }
      }
    }
    return result;
  },
};

export const Chart = {
  getChartSize: () => {
    var rootElement = document.getElementById('root');
    var positionInfo = rootElement.getBoundingClientRect();

    return {
      width: positionInfo.width > 800 ? positionInfo.width - 70 : positionInfo.width - 40,
      height: positionInfo.height / 2,
    };
  },
}